import * as React from 'react'

const Activate = (props: { className: string }) => {
  return (
    <svg
      className={'icon' + props.className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z'
        stroke='#8C97A2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.0984 5L6.60915 9.25984L4.88862 7.65761L4 8.53968L6.58265 11H6.59375L12 5.86408L11.0984 5Z'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default Activate



// WEBPACK FOOTER //
// ./src/components/icons/vehicle/Activate.tsx